const styleOverrides = {
  root: {
    color: 'inherit',
  },
};

export default styleOverrides;
